import { URL_PREFIX } from '../constants/api';

export interface RollupLock {
  hash_key: string;
  created_at: string;
  created_by: {
    email: string;
    id: number;
    name: string;
  };
}

export async function getTrackRollupIgnores(
  hashes: string[],
): Promise<RollupLock[]> {
  try {
    const resp = await fetch(
      `${URL_PREFIX}/api/v1/track-rollup-ignore/get/bulk`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hash_keys: hashes }),
      },
    );

    if (!resp.ok) {
      throw new Error(
        `Failed to fetch track rollup ignores: ${resp.statusText}`,
      );
    }

    return (await resp.json()) as RollupLock[];
  } catch (error) {
    console.error('getTrackRollupIgnores error:', error);
    throw error;
  }
}

export async function createTrackRollupIgnores(
  hashes: string[],
): Promise<RollupLock[]> {
  try {
    const resp = await fetch(
      `${URL_PREFIX}/api/v1/track-rollup-ignore/create/bulk`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hash_keys: hashes }),
      },
    );

    if (!resp.ok) {
      throw new Error(
        `Failed to create track rollup ignores: ${resp.statusText}`,
      );
    }

    return (await resp.json()) as RollupLock[];
  } catch (error) {
    console.error('createTrackRollupIgnores error:', error);
    throw error;
  }
}

export async function deleteTrackRollupIgnores(
  hashes: string[],
): Promise<void> {
  try {
    const resp = await fetch(
      `${URL_PREFIX}/api/v1/track-rollup-ignore/delete/bulk`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hash_keys: hashes }),
      },
    );

    if (!resp.ok) {
      throw new Error(
        `Failed to delete track rollup ignores: ${resp.statusText}`,
      );
    }
  } catch (error) {
    console.error('deleteTrackRollupIgnores error:', error);
    throw error;
  }
}
